import i18next from 'i18next';
import { NString } from '@mobalytics/shared';
import { PlanT } from '../payment.types';
import { TreasuryPaymentsProduct } from '../../../__generated/treasury/types';
import { getPlanDuration } from './get-plan-duration.utils';

// Names already used in Mixpanel reports; a game missing here falls back to its registry gameName.
const MIXPANEL_GAME_NAMES: Record<string, string> = {
  d2: 'Destiny 2',
  d4: 'Diablo 4',
  lol: 'LoL',
  tft: 'TFT',
  val: 'Valorant',
  dl: 'Deadlock',
  poe2: 'PoE 2',
  bzr: 'Bazaar',
  mhw: 'MHW',
  mr: 'Marvel Rivals',
  ern: 'Elden Ring Nightreign',
  zzz: 'ZZZ',
  exg: 'EG',
  news: 'News',
  bl4: 'Borderlands 4',
  h2: 'Hades 2',
  poe: 'Poe',
  rb: 'Riftbound',
  xko: 'xko',
  end: 'endfield',
  mar: 'marathon',
  ovw: 'overwatch',
  sts2: 'sts2',
  nte: 'nte',
  'battle-pass': 'reward pass',
  gi: 'Genshin',
  wowfor: 'WoW Forever',
};

export const getMixpanelPlanName = (
  plan: PlanT,
  productAbbreviation: string,
  gameName: NString,
  t: i18next.TFunction
): string | undefined => {
  const mixpanelGame = MIXPANEL_GAME_NAMES[productAbbreviation] ?? gameName ?? productAbbreviation;
  const duration = getPlanDuration(plan.interval, plan.intervalCount, t);
  switch (plan.planType) {
    case TreasuryPaymentsProduct.PLUS: {
      return `${mixpanelGame} Plus ${plan.isTrial ? 'Trial' : duration} (Stripe)`;
    }
    case TreasuryPaymentsProduct.AD_FREE: {
      return `Ad-Free ${mixpanelGame}: ${duration} (Stripe)`;
    }
  }
  return undefined;
};
